import React from 'react';
import {View, TouchableOpacity, Platform, StyleSheet} from 'react-native';
import {images} from '../../../../assets/icons';
import {useStyles} from '../../../../shared/hooks/styles';
import {ChangeParameterForm, ViewProps} from './model';
import {Field, reduxForm, InjectedFormProps} from 'redux-form';
import {BaseField} from '../../../../shared/components/baseField';
import {Forms} from '../../../../shared/models/forms';
import {Text} from '../../../../shared/components/text';
import {DeviceSize} from '../../../../shared/theme/helpers';

const Form = (props: ViewProps & InjectedFormProps<ChangeParameterForm, ViewProps>) => {
  const {style, value, type, handleSubmit, onAccept, onDecline, onChangeMode, changeMode, readonly, mask} = props;

  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      label: theme.fonts.label,
      body: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.body),
      iconColor: {
        color: theme.color.textColor,
      },
      container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: 40,
        ...mediaOnly(DeviceSize.desktop, {marginTop: changeMode ? -13 : 0}),
      },
      fieldContainer: {
        width: 1,
        minWidth: 1,
        flexGrow: 1,
        marginBottom: 11,
        marginRight: 20,
      },
      actionRow: {
        display: 'flex',
        flexDirection: 'row',
      },
      acceptContainer: {marginRight: 20},
    };
  });

  const fieldType = type === 'phone' ? 'phone' : 'text';
  const iconColor = StyleSheet.flatten(styles.iconColor).color;

  const testID = props.testID ? props.testID : `possible-change-field-id`;
  return (
    <View testID={`container-${testID}`} style={[styles.container, style]}>
      {!changeMode ? (
        <Text testID={`content-${testID}`} style={styles.body}>
          {value}
        </Text>
      ) : null}
      {changeMode ? (
        <View testID={`change-content-title-${testID}`} style={styles.fieldContainer}>
          <Field
            testIDprefix={`change-content-value-${testID}`}
            component={BaseField}
            type={fieldType}
            name={type}
            mask={mask}
            style={Platform.OS === 'web' ? {width: '100%', height: 40, marginTop: -6} : {}}
            containerStyle={Platform.OS !== 'web' ? {marginTop: -10} : {}}
            disableErrorIcon
            autoFocus
          />
        </View>
      ) : null}
      <View style={styles.actionRow}>
        {!changeMode && !readonly ? (
          <TouchableOpacity testID={`profile-pencil-possible-change-field-${type}-id`} onPress={onChangeMode}>
            <images.Pencil height={18} width={18} color={iconColor} />
          </TouchableOpacity>
        ) : null}
        {changeMode ? (
          <TouchableOpacity
            testID={`profile-check-possible-change-field-${type}-id`}
            style={styles.acceptContainer}
            onPress={handleSubmit((formData) => onAccept(type, formData))}>
            <images.Check height={24} width={24} color={iconColor} />
          </TouchableOpacity>
        ) : null}
        {changeMode ? (
          <TouchableOpacity testID={`profile-Close-possible-change-field-${type}-id`} onPress={onDecline}>
            <images.Close height={24} width={24} color={iconColor} />
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
};

export default reduxForm<ChangeParameterForm, ViewProps>({form: Forms.changeParameter})(Form);
